<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    top="10vh"
    width="80%"
    :title="$l('dialog_bing_sample_fabric_data') || '绑定样品/面料数据'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    v-el-dialog-drag
    append-to-body
  >
    <el-tabs v-model="activeName" type="border-card" style="box-shadow: none">
      <el-tab-pane :label="$l('form_sample_data') ||'样品数据'" name="sample">
        <choose-sample ref="chooseSampleInner" :type="type" />
      </el-tab-pane>
      <el-tab-pane :label="$l('form_fabric_data') ||'面料数据'" name="fabric">
        <ChooseFabric ref="chooseFabric" />
      </el-tab-pane>
    </el-tabs>

    <span slot="footer">
      <el-button v-if="!type" size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button v-if="type" size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button v-if="type" type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import ChooseFabric from './fabric-table'
export default {
  components: { ChooseFabric },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    confirmOnClose: { type: Boolean, default: true },
  },
  data() {
    return { activeName: 'sample' }
  },
  methods: {
    confirm() {
      let data

      if (this.activeName == 'sample') {
        data = this.$refs.chooseSampleInner.choiceData()
      }
      if (this.activeName == 'fabric') {
        data = this.$refs.chooseFabric.choiceData()
      }
      if (!data) return
      this.$emit('confirm', data)
      if (this.confirmOnClose) this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss">
.el-dialog__body {
  padding: 15px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>
